import { normalizeLocale, type SupportedLocale } from './config';

/** Brush inpainting labels, merged into the region-edit copy. */
export const IMAGE_INPAINT_COPY_KEYS = [
  'brushSize',
  'brush',
  'eraser',
  'editArea',
] as const;

export type ImageInpaintCopy = Record<
  (typeof IMAGE_INPAINT_COPY_KEYS)[number],
  string
>;

// Column order follows IMAGE_INPAINT_COPY_KEYS.
export const IMAGE_INPAINT_TRANSLATIONS: Record<SupportedLocale, string[]> = {
  en: ['Brush size', 'Brush', 'Eraser', 'Edit area'],
  ar: ['حجم الفرشاة', 'فرشاة', 'ممحاة', 'منطقة التعديل'],
  es: ['Tamaño del pincel', 'Pincel', 'Borrador', 'Área de edición'],
  'pt-BR': ['Tamanho do pincel', 'Pincel', 'Borracha', 'Área de edição'],
  fr: ['Taille du pinceau', 'Pinceau', 'Gomme', 'Zone à modifier'],
  it: ['Dimensione pennello', 'Pennello', 'Gomma', 'Area da modificare'],
  ko: ['브러시 크기', '브러시', '지우개', '편집 영역'],
  de: ['Pinselgröße', 'Pinsel', 'Radierer', 'Bearbeitungsbereich'],
  ja: ['ブラシサイズ', 'ブラシ', '消しゴム', '編集範囲'],
  hi: ['ब्रश का आकार', 'ब्रश', 'इरेज़र', 'संपादन क्षेत्र'],
  ru: ['Размер кисти', 'Кисть', 'Ластик', 'Область изменения'],
  zh: ['画笔大小', '画笔', '橡皮擦', '编辑区域'],
  'zh-TW': ['筆刷大小', '筆刷', '橡皮擦', '編輯區域'],
  vi: ['Cỡ cọ', 'Cọ', 'Tẩy', 'Vùng chỉnh sửa'],
  id: ['Ukuran kuas', 'Kuas', 'Penghapus', 'Area edit'],
};

export function getImageInpaintCopy(locale: string): ImageInpaintCopy {
  const values = IMAGE_INPAINT_TRANSLATIONS[normalizeLocale(locale)];
  return Object.fromEntries(
    IMAGE_INPAINT_COPY_KEYS.map((key, index) => [key, values[index]!])
  ) as ImageInpaintCopy;
}
